export const FMRT_MAP_ADD = 'FMRT_MAP_ADD';
